import React from 'react';
import { BRAND, isMarketGB } from '../../constants/main';
import { TrimCarouselStyledAC } from './AC/TrimCarouselStyled.AC';
import { TrimCarouselStyledAP } from './AP/TrimCarouselStyled.AP';
import { TrimCarouselStyledDS } from './DS/TrimCarouselStyled.DS';
import { TrimCarouselStyledOV } from './OV/TrimCarouselStyled.OV';
import { TrimCarouselStyledOVGB } from './OV/GB/TrimCarouselStyled.OV';
import { TrimCarouselStyled } from './TrimCarouselStyled';
import { SC } from '../../styles/theme';
import { ITrimItem, ITrimConfigurations } from '../../redux/trimSelector/trimSelector.duck.interface';

export type TrimCarouselProps = SC & {
    filteredTrims: ITrimItem[];
    filteredOutTrims: ITrimItem[];
    disabled?: boolean;
    trimConfigurations: ITrimConfigurations;
    usingFilters?: boolean;
    isStockSliceCarousel?: boolean;
    normalizeEnabled?: boolean;
};

const TrimCarousel = (props: TrimCarouselProps) => {
    if (BRAND === 'OV') return isMarketGB ? <TrimCarouselStyledOVGB {...props} /> : <TrimCarouselStyledOV {...props} />;
    if (BRAND === 'AC') return <TrimCarouselStyledAC {...props} />;
    if (BRAND === 'AP') return <TrimCarouselStyledAP {...props} />;
    if (BRAND === 'DS') return <TrimCarouselStyledDS {...props} />;
    return <TrimCarouselStyled {...props} />;
};

export default TrimCarousel;
